import { INTENT_TYPE } from '../../constants';
import { type IntentMatcher } from '../../types';

/**
 * PORTED FROM: `HeuristicUtils.matchesNumericPattern` / `NUMERIC_PATTERN`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/util/HeuristicUtils.java#lines-17
 *
 * Note this accepts *several* whitespace-separated numbers, not just one, and
 * allows a leading minus and a single decimal point on each.
 */
const NUMERIC_PATTERN = /^-?\d+(\.\d+)?(\s+-?\d+(\.\d+)?)*$/;

/**
 * Whether the input is entirely numeric.
 *
 * @example
 * matchesNumericPattern('123');        // true
 * matchesNumericPattern('-1.5 2 30');  // true
 * matchesNumericPattern('123abc');     // false
 */
export const matchesNumericPattern = (query: string): boolean => NUMERIC_PATTERN.test(query.trim());

/**
 * PORTED FROM: the third branch of `GninHeuristicStrategy.classifyInternal`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/services/strategy/GninHeuristicStrategy.java#lines-85
 *
 * ```java
 * if (HeuristicUtils.matchesNumericPattern(trimmedQuery)) {
 *     return new JiraClassificationResult(GNIN, NUMERIC);
 * }
 * ```
 *
 * A bare number is treated as navigational because it is most likely a work
 * item id.
 */
export const numericMatcher: IntentMatcher = {
	pattern: 'NUMERIC',
	type: INTENT_TYPE.GNIN,
	matches: matchesNumericPattern,
};
